import ScrollButton from "../../components/ScrollButton";
import { useEffect } from "react";

const Teaching = () => {
  useEffect(() => {
    document.title = "Teaching | Zoe-Alanah Robert";
  });
  return (
    <article className="about-main">
      <section>
        <h2 className="title-font pink-text">Teaching</h2>
        <ul className="cv-list">
          <li><a href="https://cs.nyu.edu/dynamic/courses/schedule/?semester=fall_2022" target="_blank" rel="noopener noreferrer">NYU Introduction to Programming in Python Adjunct Lecturer</a> (2022)</li>
          <li><a href="https://www.microsoft.com/en-us/teals" target="_blank" rel="noopener noreferrer">Microsoft TEALS AP Computer Science Volunteer</a> (2020-2021)</li>
          <li>Stanford Teaching Assistant in CS X Ethics and Computer Systems in C (2017-2018)</li>
          <li>Private Scratch Tutor for <a href="https://breakoutmentors.com/" target="_blank" rel="noopener noreferrer">Breakout Mentors</a> (2014-2017)</li>
          <li><a href="https://cs198.stanford.edu/cs198/Default.aspx" target="_blank" rel="noopener noreferrer">Stanford Senior Section Leader</a> (2013-2017)</li>
          <li>Research Assistant at the <a href="https://sites.cc.gatech.edu/campice/" target="_blank" rel="noopener noreferrer">Georgia Tech Institute For Computing Education</a> (2012-2013)</li>
        </ul>
      </section>
      <ScrollButton />
    </article>
  );
};

export default Teaching;
